import { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { HouseContext } from "../../../../context/HouseContext";
import FileDnd from "../../../../components/FileDnD";
import FormField from "../../../../components/FormFiel/FormFiel";
import { useForm } from "react-hook-form";
import { v4 as uuidv4 } from "uuid";
import { saveNewProperty } from "../../../../application/saveProperty";
import { saveMultipleImages } from "../../../../application/saveImg";
import { BounceLoader } from "react-spinners";
import InstagramImport from "../../../../components/InstagramImport/InstagramImport";
import {
  FaCamera,
  FaHome,
  FaMapMarkerAlt,
  FaListUl,
  FaAlignLeft,
  FaMap,
  FaStar,
  FaDollarSign,
  FaInstagram,
  FaCheckCircle,
  FaPlusCircle,
  FaTimesCircle,
} from "react-icons/fa";

function SectionCard({ icon: Icon, title, children, className = "" }) {
  return (
    <div className={`bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-100 dark:border-gray-700 overflow-hidden ${className}`}>
      <div className="flex items-center gap-2.5 px-5 py-3.5 bg-gray-50 dark:bg-gray-800/80 border-b border-gray-100 dark:border-gray-700">
        <Icon className="w-4 h-4 text-primary" />
        <h2 className="text-sm font-semibold text-gray-700 dark:text-gray-200">{title}</h2>
      </div>
      <div className="p-5">{children}</div>
    </div>
  );
}

function SuccessModal({ onNewProperty, onGoHome }) {
  return (
    <div className="fixed inset-0 bg-gray-900/60 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl max-w-md w-full p-8 text-center">
        <div className="flex items-center justify-center w-16 h-16 bg-green-100 dark:bg-green-900/30 rounded-full mx-auto mb-4">
          <FaCheckCircle className="w-8 h-8 text-green-500" />
        </div>
        <h2 className="text-xl font-bold text-gray-800 dark:text-gray-100 mb-2">
          Propiedad guardada
        </h2>
        <p className="text-gray-500 dark:text-gray-400 mb-6">
          La propiedad fue cargada con exito.
        </p>
        <div className="flex flex-col sm:flex-row gap-3">
          <button
            onClick={onNewProperty}
            className="flex-1 flex items-center justify-center gap-2 px-5 py-3 bg-primary hover:bg-secondary text-white font-semibold rounded-lg transition-colors"
          >
            <FaPlusCircle className="w-4 h-4" />
            Cargar otra
          </button>
          <button
            onClick={onGoHome}
            className="flex-1 flex items-center justify-center gap-2 px-5 py-3 bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600 text-gray-700 dark:text-gray-200 font-semibold rounded-lg transition-colors"
          >
            <FaHome className="w-4 h-4" />
            Ir al inicio
          </button>
        </div>
      </div>
    </div>
  );
}

function ErrorModal({ message, onClose }) {
  return (
    <div className="fixed inset-0 bg-gray-900/60 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl max-w-md w-full p-8 text-center">
        <div className="flex items-center justify-center w-16 h-16 bg-red-100 dark:bg-red-900/30 rounded-full mx-auto mb-4">
          <FaTimesCircle className="w-8 h-8 text-red-500" />
        </div>
        <h2 className="text-xl font-bold text-gray-800 dark:text-gray-100 mb-2">
          Error al guardar
        </h2>
        <p className="text-gray-500 dark:text-gray-400 mb-6">{message}</p>
        <button
          onClick={onClose}
          className="px-6 py-3 bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600 text-gray-700 dark:text-gray-200 font-semibold rounded-lg transition-colors"
        >
          Cerrar
        </button>
      </div>
    </div>
  );
}

function PropertyCreate() {
  const navigate = useNavigate();
  const { refreshHouses } = useContext(HouseContext);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);
  const [files, setFiles] = useState([]);
  const [instagramFiles, setInstagramFiles] = useState([]);
  const [formKey, setFormKey] = useState(0);
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    reset,
    formState: { errors },
  } = useForm();

  const currency = watch("currency");
  const state = watch("state");

  const handleFiles = (files) => {
    if (Array.isArray(files)) {
      setFiles(files);
    } else {
      console.error("handleFiles: El valor recibido no es un array");
    }
  };

  const handleInstagramImport = ({ fields, files: importedFiles }) => {
    if (fields.name) setValue("name", fields.name);
    if (fields.type) setValue("type", fields.type);
    if (fields.state) setValue("state", fields.state);
    if (fields.country) setValue("country", fields.country);
    if (fields.address) setValue("address", fields.address);
    if (fields.ambientes) setValue("ambientes", fields.ambientes);
    if (fields.dormitorios) setValue("dormitorios", fields.dormitorios);
    if (fields.baños) setValue("baños", fields.baños);
    if (fields.patio) setValue("patio", fields.patio);
    if (fields.expensas) setValue("expensas", fields.expensas);
    if (fields.description) setValue("description", fields.description);
    if (fields.currency) setValue("currency", fields.currency);
    if (fields.price) setValue("price", fields.price);
    if (fields.contrato) setValue("contrato", fields.contrato);
    if (fields.maps) setValue("maps", fields.maps);

    if (importedFiles && importedFiles.length > 0) {
      setInstagramFiles(importedFiles);
      setFiles(importedFiles);
    }
  };

  function generateShortId() {
    return uuidv4().split("-")[0];
  }

  const toTitleCase = (str) =>
    str ? str.trim().replace(/\b\w/g, (c) => c.toUpperCase()) : "";

  const onSubmit = async (formData) => {
    setLoading(true);
    try {
      const propertyId = generateShortId();
      const resultStorage = await saveMultipleImages(files, propertyId);
      const formattedData = {
        id: propertyId,
        name: toTitleCase(formData.name),
        type: formData.type,
        state: formData.state,
        country: toTitleCase(formData.country),
        address: toTitleCase(formData.address),
        characteristics: {
          ambientes: formData.ambientes || "",
          dormitorios: formData.dormitorios || "",
          baños: formData.baños || "",
          patio: formData.patio || "",
          expensas: formData.expensas || "",
          estado: formData.estado || "",
          plantas: formData.plantas || "",
          contrato: formData.contrato || "",
        },
        description: formData.description,
        currency: formData.currency || "",
        price: formData.price || "",
        maps: formData.maps,
        highlights: formData.highlights === "true" ? true : false,
        images: resultStorage,
      };

      await saveNewProperty(formattedData);
      await refreshHouses();
      reset();
      setFiles([]);
      setInstagramFiles([]);
      setFormKey((prev) => prev + 1);
      setLoading(false);
      setSuccess(true);
    } catch (err) {
      console.error("Error al guardar la propiedad:", err);
      setLoading(false);
      setError("No se pudo guardar la propiedad. Revisa los datos e intenta de nuevo.");
    }
  };

  return (
    <div className="px-4 md:px-6 py-4">
      {/* Loading overlay */}
      {loading && (
        <div className="fixed inset-0 bg-gray-900/60 backdrop-blur-sm flex items-center justify-center z-50">
          <div className="flex flex-col justify-center items-center bg-white dark:bg-gray-800 rounded-2xl p-8 shadow-2xl">
            <BounceLoader className="my-2" color="#187795" size={60} />
            <h2 className="text-lg font-semibold mt-4 text-gray-700 dark:text-gray-100">Guardando propiedad...</h2>
          </div>
        </div>
      )}

      {/* Success modal */}
      {success && (
        <SuccessModal
          onNewProperty={() => {
            setSuccess(false);
            window.scrollTo({ top: 0 });
          }}
          onGoHome={() => navigate("/dashboard")}
        />
      )}

      {/* Error modal */}
      {error && (
        <ErrorModal
          message={error}
          onClose={() => setError(null)}
        />
      )}

        <div className="max-w-4xl mx-auto space-y-5">
          {/* Page Header */}
          <div className="flex items-center gap-3 mb-2">
            <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-primary/10">
              <FaHome className="w-5 h-5 text-primary" />
            </div>
            <div>
              <h1 className="text-xl font-bold text-gray-800 dark:text-gray-100">Nueva Propiedad</h1>
              <p className="text-sm text-gray-500 dark:text-gray-400">Completa los datos para publicar</p>
            </div>
          </div>

          {/* Instagram Import */}
          <SectionCard icon={FaInstagram} title="Importar desde Instagram">
            <InstagramImport key={`ig-${formKey}`} onImportComplete={handleInstagramImport} />
          </SectionCard>

          {/* Images */}
          <SectionCard icon={FaCamera} title="Imagenes">
            <FileDnd key={`files-${formKey}`} onFilesChange={handleFiles} initialFiles={instagramFiles} />
          </SectionCard>

          <form onSubmit={handleSubmit(onSubmit)} className="space-y-5">
            {/* Basic Data */}
            <SectionCard icon={FaHome} title="Datos principales">
              <div className="space-y-4">
                <FormField
                  label="Nombre"
                  id="name"
                  name="nombre"
                  type="text"
                  required={true}
                  maxLength={50}
                  placeholder="Ej: Casa en barrio norte"
                  autoComplete="off"
                  errors={errors}
                  register={register}
                />
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <FormField
                    label="Tipo"
                    id="type"
                    required={true}
                    name="tipo"
                    type="select"
                    errors={errors}
                    register={register}
                    options={[
                      { value: "", label: "Seleccionar tipo" },
                      { value: "Casa", label: "Casa" },
                      { value: "Departamento", label: "Departamento" },
                      { value: "Galpón", label: "Galpón" },
                      { value: "Local", label: "Local" },
                      { value: "Oficina", label: "Oficina" },
                      { value: "Terreno", label: "Terreno" },
                    ]}
                  />
                  <FormField
                    label="Estado"
                    id="state"
                    required={true}
                    name="estado"
                    type="select"
                    errors={errors}
                    register={register}
                    options={[
                      { value: "", label: "Seleccionar estado" },
                      { value: "Alquiler", label: "Alquiler" },
                      { value: "Alquilado", label: "Alquilado" },
                      { value: "Venta", label: "Venta" },
                      { value: "Vendido", label: "Vendido" },
                    ]}
                  />
                </div>
              </div>
            </SectionCard>

            {/* Location */}
            <SectionCard icon={FaMapMarkerAlt} title="Ubicacion">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <FormField
                  label="Localidad"
                  id="country"
                  name="localidad"
                  required={true}
                  type="text"
                  maxLength={20}
                  placeholder="Ej: Chascomus"
                  autoComplete="off"
                  errors={errors}
                  register={register}
                />
                <FormField
                  label="Direccion"
                  id="address"
                  name="dirección"
                  required={true}
                  type="text"
                  maxLength={45}
                  placeholder="Ej: Av. San Martin 123"
                  autoComplete="off"
                  errors={errors}
                  register={register}
                />
              </div>
            </SectionCard>

            {/* Characteristics */}
            <SectionCard icon={FaListUl} title="Caracteristicas">
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                <FormField
                  label="Ambientes"
                  id="ambientes"
                  name="ambientes"
                  required={false}
                  type="number"
                  maxLength={10}
                  placeholder="0"
                  autoComplete="off"
                  errors={errors}
                  register={register}
                />
                <FormField
                  label="Dormitorios"
                  id="dormitorios"
                  name="dormitorios"
                  required={false}
                  type="number"
                  maxLength={10}
                  placeholder="0"
                  autoComplete="off"
                  errors={errors}
                  register={register}
                />
                <FormField
                  label="Banos"
                  id="baños"
                  name="baños"
                  required={false}
                  type="number"
                  maxLength={10}
                  placeholder="0"
                  autoComplete="off"
                  errors={errors}
                  register={register}
                />
                <FormField
                  label="Patio"
                  id="patio"
                  required={false}
                  name="patio"
                  type="select"
                  errors={errors}
                  register={register}
                  options={[
                    { value: "", label: "Seleccionar" },
                    { value: "Si", label: "Si" },
                    { value: "No", label: "No" },
                  ]}
                />
                <FormField
                  label="Expensas"
                  id="expensas"
                  required={false}
                  name="expensas"
                  type="select"
                  errors={errors}
                  register={register}
                  options={[
                    { value: "", label: "Seleccionar" },
                    { value: "Si", label: "Si" },
                    { value: "No", label: "No" },
                  ]}
                />
                <FormField
                  label="Estado del inmueble"
                  id="estado"
                  required={false}
                  name="estado"
                  type="select"
                  errors={errors}
                  register={register}
                  options={[
                    { value: "", label: "Seleccionar" },
                    { value: "Nuevo", label: "Nuevo" },
                    { value: "Usado", label: "Usado" },
                    { value: "Bueno", label: "Bueno" },
                    { value: "Muy Bueno", label: "Muy Bueno" },
                    { value: "Exelente", label: "Exelente" },
                  ]}
                />
                <FormField
                  label="Plantas"
                  id="plantas"
                  name="plantas"
                  required={false}
                  type="number"
                  maxLength={10}
                  placeholder="0"
                  autoComplete="off"
                  errors={errors}
                  register={register}
                />
                <FormField
                  label="Contrato"
                  id="contrato"
                  name="contrato"
                  required={false}
                  type="text"
                  maxLength={50}
                  placeholder="Ej: 2 anos"
                  autoComplete="off"
                  errors={errors}
                  register={register}
                />
              </div>
            </SectionCard>

            {/* Description */}
            <SectionCard icon={FaAlignLeft} title="Descripcion">
              <FormField
                label="Descripcion de la propiedad"
                id="description"
                name="descripcion"
                required={true}
                type="textarea"
                rows={6}
                placeholder="Describe la propiedad, sus comodidades, ubicacion, etc..."
                errors={errors}
                register={register}
              />
            </SectionCard>

            {/* Google Maps */}
            <SectionCard icon={FaMap} title="Mapa">
              <FormField
                label="URL de Google Maps"
                id="maps"
                name="mapa"
                required={true}
                type="text"
                placeholder="https://www.google.com/maps?q=..."
                autoComplete="off"
                errors={errors}
                register={register}
              />
              <p className="text-xs text-gray-400 dark:text-gray-500 mt-2">
                Pega el link de Google Maps para mostrar la ubicacion en el mapa
              </p>
            </SectionCard>

            {/* Highlight */}
            <SectionCard icon={FaStar} title="Destacar propiedad">
              <FormField
                label="Destacar"
                id="highlights"
                required={false}
                name="destacar propiedad"
                type="select"
                errors={errors}
                register={register}
                options={[
                  { value: "", label: "Seleccionar" },
                  { value: true, label: "Si" },
                  { value: false, label: "No" },
                ]}
              />
              <p className="text-xs text-gray-400 dark:text-gray-500 mt-2">
                Las propiedades destacadas aparecen primero en la lista de resultados.
              </p>
            </SectionCard>

            {/* Price */}
            {state !== "Alquilado" && state !== "Vendido" && (
              <SectionCard icon={FaDollarSign} title="Precio">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <FormField
                    label="Moneda"
                    id="currency"
                    required={true}
                    name="moneda"
                    type="select"
                    errors={errors}
                    register={register}
                    options={[
                      { value: "", label: "Seleccionar moneda" },
                      { value: "$", label: "$ (Pesos)" },
                      { value: "USD", label: "USD (Dolares)" },
                      { value: "Consultar", label: "Consultar" },
                    ]}
                  />
                  {currency !== "Consultar" && (
                    <FormField
                      label="Precio"
                      id="price"
                      name="precio"
                      required={true}
                      type="number"
                      maxLength={10}
                      placeholder="0"
                      autoComplete="off"
                      errors={errors}
                      register={register}
                    />
                  )}
                </div>
              </SectionCard>
            )}

            {/* Spacer for sticky button */}
            <div className="h-20"></div>

            {/* Submit - sticky bottom */}
            <div className="fixed bottom-0 left-0 lg:left-64 right-0 bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 px-6 py-3 z-20">
              <div className="max-w-4xl mx-auto flex justify-end">
                <button
                  type="submit"
                  disabled={loading}
                  className="px-8 py-3 text-white font-semibold bg-primary hover:bg-secondary rounded-lg transition-colors shadow-sm disabled:opacity-50"
                >
                  Guardar Propiedad
                </button>
              </div>
            </div>
          </form>
        </div>
    </div>
  );
}

export default PropertyCreate;
